import React, {useState} from 'react';
import {Form, Input} from 'antd';
import {MailOutlined} from '@ant-design/icons';
import {useAppDispatch} from '@nutastic/nutastic-react-app';
import {quickCall} from '../../../../state/actions.mjs';
import makeFetchCall from "../../../../utils/makeFetchCall";
import classnames from "classnames";

const componentClass = 'accountValidationForm';

export const AccountValidationForm = ({ emailValue, onValidationComplete }) => {
    const appDispatch = useAppDispatch();
    const [isMakingCall, setIsMakingCall] = useState(false);
    const classes = classnames(componentClass, 'nuAntForm');

    const initialCredential = {
        email: emailValue || '',
    };

    const onLoginClick = ({ email }) => {
        const onComplete = (response) => {
            console.log('Validation Complete', response);
            const isValid = response?.result;
            setIsMakingCall(false);
            onValidationComplete && onValidationComplete(email, isValid);
        }
        appDispatch(quickCall({
            title: 'validating user',
            asyncFetchCall: async () => {
                return await makeFetchCall('/api/auth/validateEmail', { email: email })
            },
            onSuccess: onComplete,
            onError: onComplete
        }));
    };

    return <div className={componentClass}>
        <div className={`${componentClass}__message`}>
            <h2>NuStation Account</h2>
            <p>Enter your email below to continue. The NuStation uses your email to identify your account before you register or log in.</p>
        </div>
        <Form layout="vertical" initialValues={initialCredential} onFinish={onLoginClick}>
            <Form.Item name="email" rules={[{ required: true, message: 'Enter your email', type: 'email' }]}>
                <Input prefix={<MailOutlined className="text-primary"/>} placeholder="user@nutastic.net"/>
            </Form.Item>
            <Form.Item className="mt-3">
                <button type="submit" className="btn btn-primary btn-block" disabled={isMakingCall}>Continue</button>
            </Form.Item>
        </Form>
    </div>;
};

export default AccountValidationForm;
